import * as React from 'react';
import './PodcastCard.css';
import { AppStore } from '../../../stores';
import { inject, observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import NativeService from '../../../services/NativeService';

export interface IProps {
  id: string;
  title: string;
  image?: string;
  speaker?: string;
  description?: string;
  podcastDuration?: string;
  category?: "Mindjuice" | "Speakers" | "Meditation";
  duration?: number;
  progress?: number;
  width: number;
  marginRight: number;
  selected: boolean;
  views: number;
  onClick: () => void;
  appStore?: AppStore;
}

export interface IState {
}

@inject('appStore')
@observer
export default class PodcastCard extends React.Component<IProps, IState> {

  constructor(props) {
    super(props);
    this.state = {
    }
  }

  render() {
    let height = this.props.appStore!.isMobile ? this.props.width + 155 : this.props.width + 175;
    if (this.props.duration && this.props.progress) {
      height = height + 20;
    }
    return (
      <Link to={this.props.category === "Meditation" ? `${this.props.appStore!.environment}/meditations/?podcast=${this.props.id}`: `${this.props.appStore!.environment}/inspiration/?podcast=${this.props.id}`}>
        <div
          className='podcastCard'
          style={{
            width: this.props.width,
            height: height,
            marginRight: this.props.marginRight,
            backgroundColor: this.props.selected && !this.props.appStore!.isMobile ? "#353535" : "#282828"
          }}
          onClick={() => this.props.onClick()}
        >
          <div
            className="podcastCardImage"
            style={{
              backgroundImage: `url(${this.props.image}`,
              height: this.props.width,
              width: this.props.width
            }}
          />
          <div
            className="podcastCardTitle"
          >
            {this.props.title}
          </div>
          <div
            className="podcastCardSpeaker"
          >
            {this.props.speaker}
          </div>
          {this.props.podcastDuration &&
            <div
              className="podcastDuration"
            >
              {this.props.podcastDuration}
            </div>
          }
          <div
            className='share'
            style={{
              bottom: this.props.duration && this.props.duration ? (this.props.appStore!.isMobile ? 30 : 35) : (this.props.appStore!.isMobile ? 10 : 15)
            }}
            onClick={() => {
              if (window.platform === "ios" || window.platform === "android") {
                setTimeout(() => {
                  NativeService.share(window.loc.strings.sharePodcast, `https://dojo.mindjuice.com/metadata.php?&title=${encodeURIComponent(this.props.title)}&description=${encodeURIComponent(this.props.description)}&image=${encodeURIComponent(this.props.image)}&url=${encodeURIComponent(location.href)}`);      
                }, 100);
              } else {
                this.props.appStore!.shareContent = {
                  title: this.props.title,
                  description: this.props.description,
                  image: this.props.image
                }
              }
              setTimeout(() => {
                this.props.appStore!.podcastToPlay = undefined;
              }, 0);
            }}
          />
          {/* {this.props?.views &&
            <div
              className='views'
              style={{
                bottom: this.props.appStore!.isMobile ? (this.props.duration && this.props.duration ? 34 : 14) : (this.props.duration && this.props.duration ? 39 : 19)
              }}
            >
              <div className='viewsIcon'>
                {IconService.getIcon("Headphones Sound Wave", "#ffffff")}
              </div>
              {`${this.props?.views} ${window.loc.strings.views}`}
            </div>
          } */}
          {this.props.duration && this.props.progress &&
            <progress
              max={this.props.duration}
              value={this.props.progress}
            />
          }
        </div>
      </Link>
    );
  }
}